export enum AssignEntityTagErrorcodes {
  ASSIGN_TAG_TO_ENTITY_IS_ONLY_SUPPORTED_FOR_PRODUCT = 'ASSIGN_TAG_TO_ENTITY_IS_ONLY_SUPPORTED_FOR_PRODUCT',
  ASSIGN_TAG_TO_ENTITY_IS_NOT_ALLOWED_FOR_BASIC_LICENSE_TYPE = 'ASSIGN_TAG_TO_ENTITY_IS_NOT_ALLOWED_FOR_BASIC_LICENSE_TYPE',
  ASSIGN_TAG_TO_ENTITY_MAX_LIMIT_REACHED = 'ASSIGN_TAG_TO_ENTITY_MAX_LIMIT_REACHED',
  ASSIGN_TAG_TO_ENTITY_VALIDATION_ERROR = 'ASSIGN_TAG_TO_ENTITY_VALIDATION_ERROR',
}

export const AssignEntityTagErrorcodesTranslationKeyMap = {
  [AssignEntityTagErrorcodes.ASSIGN_TAG_TO_ENTITY_IS_ONLY_SUPPORTED_FOR_PRODUCT]:
    'assignToProducts',
  [AssignEntityTagErrorcodes.ASSIGN_TAG_TO_ENTITY_MAX_LIMIT_REACHED]: 'assignTagMaxLimit',
  [AssignEntityTagErrorcodes.ASSIGN_TAG_TO_ENTITY_VALIDATION_ERROR]: 'companyNotFound',
  [AssignEntityTagErrorcodes.ASSIGN_TAG_TO_ENTITY_IS_NOT_ALLOWED_FOR_BASIC_LICENSE_TYPE]:
    'assignTagNotAllowed',
};
